import { jsx, jsxs } from "react/jsx-runtime";
import {
  Avatar,
  __css,
  mergeClasses,
  Tooltip,
  tokens
} from "@fluentui/react-components";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocale } from "../internal/use-locale.js";
import { OrgAvatar } from "../org-avatar/org-avatar.js";
import { initialsOf } from "../internal/initials.js";
const PRESENCE_STATES = [
  "available",
  "busy",
  "in_meeting",
  "on_site",
  "away",
  "offline"
];
const BADGE_STATUS = {
  available: "available",
  busy: "busy",
  in_meeting: "do-not-disturb",
  on_site: "out-of-office",
  away: "away",
  offline: "offline"
};
const useStyles = __css({"root":{"qhf8xq":"f10pi13n","mc9l5x":"ftuwxu6","Bnnss6s":"fi64zpg"},"presence":{"Bpd4iqm":"f2znb4n","oeaueh":"f1yog68k","Bw0xxkn":"fcvzvvt"},"org":{"qhf8xq":"f1euv43f","Bwk1v6v":"f12fkyep","Bvbap8t":"f1gn2l62","E5pizo":"fwoxyjy","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"ft85np5"},"orgSmall":{"Bwk1v6v":"f1vpmtir","Bvbap8t":"f4jzno9"}});
function UserAvatar({
  name,
  imageUrl,
  presence,
  statusMessage,
  organisation,
  size = 32,
  className
}) {
  const { t } = useTranslation("ui");
  const locale = useLocale();
  const styles = useStyles();
  const label = useMemo(() => {
    const parts = [name];
    if (presence) parts.push(t(`shell.presence.${presence}`));
    if (statusMessage)
      parts.push(t("components.userAvatar.statusMessage", { message: statusMessage }));
    if (organisation)
      parts.push(t("components.userAvatar.organisation", { name: organisation.name }));
    return new Intl.ListFormat(locale, { type: "unit", style: "narrow" }).format(parts);
  }, [name, presence, statusMessage, organisation, locale, t]);
  const orgSize = size >= 56 ? 28 : size >= 40 ? 20 : 16;
  const avatar = /* @__PURE__ */ jsxs("span", { className: mergeClasses(styles.root, className), children: [
    /* @__PURE__ */ jsx(
      Avatar,
      {
        name,
        initials: initialsOf(name),
        size,
        color: "colorful",
        "aria-label": label,
        ...imageUrl ? { image: { src: imageUrl } } : {},
        ...presence ? {
          badge: {
            status: BADGE_STATUS[presence],
            "aria-hidden": true,
            className: styles.presence
          }
        } : {}
      }
    ),
    organisation ? /* @__PURE__ */ jsx("span", { className: mergeClasses(styles.org, size < 40 && styles.orgSmall), "aria-hidden": "true", children: /* @__PURE__ */ jsx(
      OrgAvatar,
      {
        name: organisation.name,
        size: orgSize,
        decorative: true,
        ...organisation.logoUrl ? { logoUrl: organisation.logoUrl } : {}
      }
    ) }) : null
  ] });
  return statusMessage ? /* @__PURE__ */ jsx(Tooltip, { content: statusMessage, relationship: "inaccessible", children: avatar }) : avatar;
}
export {
  PRESENCE_STATES,
  UserAvatar
};
//# sourceMappingURL=user-avatar.js.map

import "/opt/batiflow/app/packages/ui/dist/components/user-avatar/user-avatar.griffel.css";